import { onMounted, onUnmounted, ref } from "vue";
import { useState } from "@/store/vuex-composition-mappers";

export function useDragAndDrop({ onBlockDropped, onToolDropped }) {
    const { preview } = useState("shared/view", ["preview"]);
    const insertPosition = ref(null);
    const isDragging = ref(false);

    function resetDropState() {
        isDragging.value = false;
        const dropIndicator = document
            .querySelector("[data-dnd-container='true']")
            .querySelector("[data-dnd='drop-indicator']");
        dropIndicator.classList.add("hidden");
    }

    function handleDragOver(e) {
        e.preventDefault();
        if (!e.dataTransfer.types.includes("new-easypage-section")) return;

        isDragging.value = true;

        const dropIndicator = document
            .querySelector("[data-dnd-container='true']")
            .querySelector("[data-dnd='drop-indicator']");
        const rect = document.body.getBoundingClientRect();
        const y = e.clientY - rect.top;

        const blocks = Array.from(
            document
                .querySelector("[data-dnd-container='true']")
                .querySelectorAll("[data-dnd='section']")
        );
        console.log("blocks", blocks);
        let insertBeforeElement = null;

        for (let i = 0; i < blocks.length; i++) {
            const blockRect = blocks[i].getBoundingClientRect();
            const blockMidY = blockRect.top + blockRect.height / 2 - rect.top;

            if (y < blockMidY) {
                insertBeforeElement = blocks[i];
                insertPosition.value = i;
                break;
            }
        }

        positionDropIndicator(insertBeforeElement, blocks, rect, dropIndicator);
    }

    function positionDropIndicator(insertBeforeElement, blocks, rect, dropIndicator) {
        console.log("positionDropIndicator", insertBeforeElement, blocks, rect, dropIndicator);
        if (insertBeforeElement) {
            const targetRect = insertBeforeElement.getBoundingClientRect();
            dropIndicator.style.top = `${targetRect.top - rect.top}px`;
        } else {
            insertPosition.value = blocks.length;
            const lastBlock = blocks[blocks.length - 1];
            if (lastBlock) {
                const lastBlockRect = lastBlock.getBoundingClientRect();
                console.log("lastBlockRect", lastBlockRect, lastBlock);
                dropIndicator.style.top = `${lastBlockRect.bottom - rect.top - 2}px`;
            } else {
                dropIndicator.style.top = "0px";
            }
        }

        dropIndicator.classList.remove("hidden");
    }

    function handleDrop(e) {
        e.preventDefault();
        if (!e.dataTransfer.types.includes("new-easypage-section")) return;

        const { type, data } = JSON.parse(e.dataTransfer.getData("new-easypage-section"));

        if (type === "block") {
            onBlockDropped({
                block: data,
                position: insertPosition.value,
            });
        } else if (type === "tool") {
            onToolDropped({
                project: data,
                position: insertPosition.value,
            });
        }

        resetDropState();
    }

    function handleDragEnd() {
        resetDropState();
    }

    function handleDragLeave(e) {
        if (
            e.clientY <= 0 ||
            e.clientX <= 0 ||
            e.clientX >= window.innerWidth ||
            e.clientY >= window.innerHeight
        ) {
            resetDropState();
        }
    }

    onMounted(() => {
        if (!preview.value) return;

        document.body.addEventListener("dragover", handleDragOver);
        document.body.addEventListener("drop", handleDrop);
        document.body.addEventListener("dragend", handleDragEnd);
        document.body.addEventListener("dragleave", handleDragLeave);
    });

    onUnmounted(() => {
        if (!preview.value) return;

        document.body.removeEventListener("dragover", handleDragOver);
        document.body.removeEventListener("drop", handleDrop);
        document.body.removeEventListener("dragend", handleDragEnd);
        document.body.removeEventListener("dragleave", handleDragLeave);
    });

    return {
        isDragging,
    };
}
